module.exports = "<svg width=\"8\" height=\"12\" viewBox=\"0 0 8 12\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M1.305 0L0 1.579l4.933 4.42L0 10.419 1.305 12 8 5.999z\" fill=\"#15100c\" fill-rule=\"evenodd\"/>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./assets/svg/arrow-accessory-right.svg
// module id = 3693
// module chunks = 168707334958949